import React from "react";

import './WindowAttribute.css';

const WindowAttribute = (props) => {
    const { fldName, fldValue } = props;

    return (
        <div className='clsWinAttr'>
            <div className='clsWinAttr-fldName'>{ fldName }</div>
            <div className='clsWinAttr-fldValue'>{ fldValue }</div>
        </div>
    );
}

export default WindowAttribute;